import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var subscription = admin.getEntity("Subscriptions");
  subscription
    .listView()
    .title(
      '<h4>Subscriptions <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga
        .field("username", "string")
        .isDetailLink(false)
        .label("Username"),
      nga
        .field("mac_address", "string")
        .isDetailLink(false)
        .label("MAC Address"),
      nga
        .field("combo_name", "string")
        .isDetailLink(false)
        .label("Plan"),
      nga
        .field("start_date", "string")
        .template(function (entry) {
          if(entry.values.is_active){
            return "<span style='color: green'>"+entry.values.start_date+"</span>";
          } else{
            return "<span style='color: red'>"+entry.values.start_date+"</span>";
          }
        })
        .label("Start date"),
      nga
        .field("end_date", "string")
        .template(function (entry) {
          if(entry.values.is_active){
            return "<span style='color: green'>"+entry.values.end_date+"</span>";
          } else{
            return "<span style='color: red'>"+entry.values.end_date+"</span>";
          }
        })
        .label("End date"),
    ])
    .filters([
      nga.field('status', 'choice')
        .attributes({ placeholder: 'Select Status' })
        .label('Status')
        .choices(
          [
            { value: 'active', label: 'Active' },
            { value: 'expired', label: 'Expired' },
          ]
        ),
      nga
        .field("q")
        .template(
          '<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>'
        )
        .label("")
        .pinned(true),
    ])
    .exportFields([
      subscription.listView().fields(),
      nga
        .field("product_id", "string")
        .isDetailLink(false)
        .label("Product ID")
    ]);

  subscription
    .deletionView()
    .title(
      '<h4>Subscriptions <i class="fa fa-angle-right" aria-hidden="true"></i> Remove <span style ="color:red;"> {{ entry.values.package.package_name }} </span> from <span style ="color:red;"> {{ entry.values.login_datum.username }} </span></h4>'
    )
    .fields([
      nga.field("login_datum", "template").template(function (entry, value) {
        return entry.values.login_datum.username;
      }),
      nga.field("package", "template").template(function (entry, value) {
        return entry.values.package.package_name;
      }),
    ])
    .actions([
      '<ma-back-button entry="entry" entity="entity"></ma-back-button>',
    ]);

//   subscription
//     .creationView()
//     .title(
//       '<h4>Subscriptions <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Subscription</h4>'
//     )
//     .fields([
//       nga
//         .field("login_id", "reference_many")
//         .targetEntity(admin.getEntity("CustomerAccount"))
//         .targetField(nga.field("username"))
//         .attributes({ placeholder: "Choose Username from dropdown list" })
//         //value.length > 1 because of reference_many
//         .validation({
//           validator: function (value) {
//             if (value === null || value === "") {
//               throw new Error("Please Select username");
//             } else if (value.length > 1) {
//               throw new Error("Please select only one username");
//             }
//           },
//         })

//         .remoteComplete(true, {
//           refreshDelay: 300,
//           // populate choices from the response of GET /posts?q=XXX
//           searchQuery: function (search) {
//             return { q: search };
//           },
//         })
//         .perPage(10) // limit the number of results to 10
//         .label("Username *"),
//       nga
//         .field("combo_id", "reference_many")
//         .targetEntity(admin.getEntity("Combos"))
//         .targetField(nga.field("name"))
//         .attributes({ placeholder: "Choose Combo from dropdown list" })
//         .validation({
//           validator: function (value) {
//             if (value === null || value === "") {
//               throw new Error("Please Select Combo");
//             }
//           },
//         })
//         .perPage(-1)
//         .label("Combo *"),
//       nga
//         .field("on_behalf_id", "reference")
//         .targetEntity(admin.getEntity("userAvailable"))
//         .targetField(nga.field("username"))
//         .remoteComplete(true, {
//           // populate choices from the response of GET /posts?q=XXX
//           searchQuery: function (search) {
//             return { q: search };
//           },
//         })
//         .perPage(10) // limit the number of results to 10
//         .validation({
//           validator: function (value) {
//             if (value === null || value === "") {
//               throw new Error("Please Select On Behalf Id ");
//             }
//           },
//         })
//         .label("On Behalf Id"),
//       nga
//         .field("start_date", "date")
//         .attributes({ placeholder: "Start date" })
//         .validation({ required: true })
//         .defaultValue(new Date())
//         .label("Start date"),
//       nga
//         .field("end_date", "date")
//         .attributes({ placeholder: "End date" })
//         .validation({ required: true })
//         .defaultValue(new Date())
//         .label("End date"),
//       nga.field("template").label("").template(edit_button),
//     ])
//     .onSubmitSuccess([
//       "progression",
//       "notification",
//       "$state",
//       "entry",
//       "entity",
//       function (progression, notification, $state, entry, entity) {
//         progression.done();
//         notification.log(`Subscription added successfully`, {
//           addnCls: "humane-flatty-success",
//         });
//         $state.go($state.get("edit"), {
//           entity: "CustomerAccount",
//           id: entry.values.user,
//         });
//         return false;
//       },
//     ]);

  subscription
    .editionView()
    .title(
      '<h4>Subscriptions: Edit subscription date <i class="fa fa-angle-right" aria-hidden="true"></i></h4>'
    )
    .fields([
      nga
        .field("login_id", "reference")
        .targetEntity(admin.getEntity("LoginData"))
        .targetField(nga.field("username"))
        .editable(false)
        /*		.attributes({ placeholder: 'Select Account' })
  .validation({validator: function(value) {
  if(value === null || value === ''){
  throw new Error('Please Select Username');
  }
  }
  })*/
        .label("Username *"),
      nga
        .field("start_date", "datetime")
        .validation({
          required: true,
          validator: function (start_date_input, input_list) {
            if (start_date_input > input_list.end_date)
              throw new Error("Start date cannot be bigger than end date");
          },
        })
        .label("Start date"),
      nga
        .field("end_date", "datetime")
        .validation({
          required: true,
          validator: function (end_date_input, input_list) {
            if (end_date_input < input_list.start_date)
              throw new Error("End date cannot be smaller than start date");
          },
        })
        .label("End date"),
      nga.field("template").label("").template(edit_button),
    ])
    .onSubmitSuccess([
      "progression",
      "notification",
      "$state",
      "entry",
      "entity",
      function (progression, notification, $state, entry, entity) {
        progression.done();
        notification.log(`Subscription edit successfully`, {
          addnCls: "humane-flatty-success",
        });
        $state.go($state.get("list"), { entity: entity.name() });
        return false;
      },
    ]);

  return subscription;
}



// WEBPACK FOOTER //
// ./js/subscription/config.js